import { atomWithThunksReducer } from "utilities/atoms/atom-with-thunks-reducer";
import {
    ConversationsAction,
    conversationReducer,
    CurrentConversationState,
} from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";
import { getSavedState } from "../conversations.persistence";

export type ConversationAtom =
    | typeof ModalConversationAtom
    | typeof BookviewConversationAtom
    | typeof NotebookConversationAtom;

export const ModalConversationAtom = atomWithThunksReducer<
    CurrentConversationState,
    ConversationsAction
>(
    getSavedState("modalConversation", conversationReducer.defaultState),
    conversationReducer
);

export const BookviewConversationAtom = atomWithThunksReducer<
    CurrentConversationState,
    ConversationsAction
>(
    getSavedState("bookviewConversation", conversationReducer.defaultState),
    conversationReducer
);

export const NotebookConversationAtom = atomWithThunksReducer<
    CurrentConversationState,
    ConversationsAction
>(
    getSavedState("notebookConversation", conversationReducer.defaultState),
    conversationReducer
);
